<div class="layout-footer">
    <div class="footer-logo-container flex-wrap">
        <span style="font-size:1rem; font-weight: bold; color: var(--text-color); cursor: pointer; text-decoration: underline;" pTooltip="Voir les notes de version" (click)="openVersionDialog()">{{ version }}</span>
        <iframe src="https://hamelconstruction.betteruptime.com/fr-ca/badge?theme=dark" width="275" height="30"
            frameborder="0" scrolling="no" style="color-scheme: normal; margin-left: 1rem"></iframe>
    </div>
    <div class="flex gap-2 align-items-center">
        <span class="copyright">&#169; Hamel Construction - {{anneeCourante}}</span>
        <p-button id="button-feedback" severity="secondary" outlined icon="pi pi-exclamation-circle"
            label="Signaler un bug" size="small" />
    </div>
</div>